/** @format */

import { light } from "@mui/material/styles/createPalette";

// Alex 08JAN2024 - Set up global discount switch
// Set to true to show discount prices on Explore pages
//
const shadeTypeDiscount = true;
const roomTypeMappings = {
  "Light Filtering": [
    "Living Room",
    "Dining Room",
    "Kitchen",
    "Office",
    "Washrooms",
  ],
  Blackout: ["Bedroom", "Theatre Room", "Nursery"],
};

const roomTypes = {
  "Light Filtering": roomTypeMappings["Light Filtering"],
  Blackout: roomTypeMappings.Blackout,
  "Day and Night": [
    ...roomTypeMappings["Light Filtering"],
    ...roomTypeMappings.Blackout,
  ],
  Solar: roomTypeMappings["Light Filtering"],
  Transparent: roomTypeMappings["Light Filtering"],
  Privacy: roomTypeMappings["Light Filtering"],
};

const allProducts = [
  {
    id: "privacy-vertical-sheer",
    name: "Privacy Vertical Sheer Shade",
    type: "Vertical Sheer",
    lightControl: "Privacy",
    fabric: "Privacy",
    roomType: roomTypes.Privacy,
    price: 367.5,
    bestseller: false,
    image: "/images/newHome/shades/privacy_vertical_sheer.jpg",
    features: [
      "Soft light diffusion",
      "Elegant translucency",
      "Minimalist aesthetic",
    ],
  },
  {
    id: "blackout-vertical-sheer",
    name: "Blackout Vertical Sheer Shade",
    type: "Vertical Sheer",
    lightControl: "Blackout",
    fabric: "Blackout",
    roomType: roomTypes.Blackout,
    price: 229.5,
    bestseller: false,
    image: "/images/newHome/shades/blackout_vertical_sheer.jpg",
    features: [
      "Complete light blockage",
      "Thermal insulation",
      "Noise reduction",
    ],
  },

  {
    id: "light-filtering-simply-cellular",
    name: "Light Filtering Simply Cellular Shade",
    type: "Simply Cellular",
    lightControl: "Privacy",
    fabric: "Light Filtering",
    roomType: roomTypes["Light Filtering"],
    price: 184.5,
    bestseller: true,
    image: "/images/newHome/shades/light_cellular.jpg",
    features: ["Superior insulation", "Energy efficiency", "Noise reduction"],
  },
  {
    id: "blackout-simply-cellular",
    name: "Blackout Simply Cellular Shade",
    type: "Simply Cellular",
    lightControl: "Blackout",
    fabric: "blackout",
    roomType: roomTypes.Blackout,
    price: 271,
    bestseller: true,
    image: "/images/newHome/shades/blackout_cellular.jpg",
    features: ["Superior insulation", "Energy efficiency", "Noise reduction"],
  },
  {
    id: "day-night-simply-cellular",
    name: "Day & Night Simply Cellular Shade",
    type: "Simply Cellular",
    lightControl: "Soft Filter",
    fabric: "Day and Night",
    roomType: roomTypes["Day and Night"],
    price: 397.5,
    bestseller: true,
    image: "/images/newHome/shades/day_night_cellular.jpg",
    features: ["Superior insulation", "Energy efficiency", "Noise reduction"],
  },

  {
    id: "roller-privacy-living",
    name: "Privacy Roller Shade",
    type: "Roller",
    lightControl: "Privacy",
    fabric: "privacy",
    roomType: roomTypes["Privacy"],
    price: 198,
    bestseller: false,
    image: "/images/newHome/shades/privacy_roller2.jpg",
    features: [
      "Partial light filtering",
      "Daytime privacy",
      "Soft light diffusion",
    ],
  },
  {
    id: "roller-blackout-bedroom",
    name: "Blackout Roller Shade",
    type: "Roller",
    lightControl: "Blackout",
    fabric: "blackout",
    roomType: roomTypes.Blackout,
    price: 216,
    bestseller: true,
    image: "/images/newHome/shades/blackout_roller.jpg",
    features: [
      "Complete light blockage",
      "Thermal insulation",
      "Noise reduction",
    ],
  },
  {
    id: "solar-home-office",
    name: "Solar Roller Shade",
    type: "Roller",
    lightControl: "Solar",
    fabric: "sunscreen",
    roomType: roomTypes.Solar,
    price: 216,
    bestseller: false,
    image: "/images/newHome/shades/privacy_roller.jpg",
    features: ["View-through design", "UV protection", "Glare reduction"],
  },
  {
    id: "transparent-roller",
    name: "Transparent Roller Shade",
    type: "Roller",
    lightControl: "Transparent",
    fabric: "transparent",
    roomType: roomTypes.Transparent,
    price: 216,
    bestseller: false,
    image: "/images/newHome/shades/transparent_roller.jpg",
    features: [
      "Daytime privacy",
      "Outside view preservation",
      "Soft sheer look",
    ],
  },
  {
    id: "privacy-zebra-living",
    name: "Privacy Zebra Shade",
    type: "Zebra",
    lightControl: "Privacy",
    fabric: "privacy",
    roomType: roomTypes.Privacy,
    price: 262.5,
    bestseller: false,
    image: "/images/newHome/shades/privacy_zebra.jpg",
    features: [
      "Light filtering with privacy",
      "Adjustable light penetration",
      "Versatile design",
    ],
  },

  {
    id: "zebra-blackout-home",
    name: "Blackout Zebra Shade",
    type: "Zebra",
    lightControl: "Blackout",
    fabric: "blackout",
    roomType: roomTypes.Blackout,
    price: 360,
    bestseller: true,
    image: "/images/newHome/shades/blackout_zebra.jpg",
    features: [
      "Alternating light control",
      "Precise privacy adjustment",
      "Modern design",
    ],
  },
  {
    id: "blackout-sheer-living",
    name: "Blackout Sheer Shade",
    type: "Sheer",
    lightControl: "Soft Filter",
    fabric: "Blackout",
    roomType: roomTypes.Blackout,
    price: 416.5,
    bestseller: false,
    image: "/images/shadeinfo/shades/sheer/sheer.jpg",
    features: [
      "Soft light diffusion",
      "Elegant translucency",
      "Minimalist aesthetic",
    ],
  },
  {
    id: "privacy-sheer-living",
    name: "Privacy Sheer Shade",
    type: "Sheer",
    lightControl: "Soft Filter",
    fabric: "Privacy",
    roomType: roomTypes.Privacy,
    price: 416.5,
    bestseller: false,
    image: "/images/shadeinfo/shades/sheer/4.jpg",
    features: [
      "Soft light diffusion",
      "Elegant translucency",
      "Minimalist aesthetic",
    ],
  },
];

const BottomBarOptions = {
  "Sky Bar": {
    title: "Sky Bar",
    body: "The Square Bottom Bar is compatible with side channels and has dimensional stability in order to prevent bending on wider width shades. Anodized finish only.",
    media: ["/images/shadeinfo/bottombar-options/skybar.jpg"],
  },
  "Aluminum Hem": {
    title: "Aluminum Hem",
    body: [
      "This slim-profile bottom bar adds a touch of modern sophistication to your window treatments.",
      "With its seamless design and exceptional strength, the Aluminum Hem not only enhances the aesthetic appeal of your roller shades but also keeps the shade taut and flat.",
      "Available in White, Black, Anodized, Linen or fabric wrapped.",
    ],
    media: ["/images/shadeinfo/bottombar-options/aluminum.jpg"],
  },
  // "Plain Hem": {
  // 	title: "Plain Hem",
  // 	body: 'The Plain Hem bottom bar features a 1.75" welded pocket, meticulously crafted with precision. The aluminum slat insert ensures durability and a sleek appearance.',
  // 	media: ["/images/shadeinfo/bottombar-options/plain-hem.jpg"],
  // },
  //remove Banded Bar based on feedback from Zach
  // "Banded Bar": {
  // 	title: "Banded Bar",
  // 	body: "Crafted with a sleek and modern aesthetic, our aluminum bar exudes a contemporary charm, adding a touch of elegance to your space. With its internal roller mechanism, the banded fabric effortlessly glides through, ensuring a seamless and smooth operation. Choose from a range of stylish options, including white, anodized, linen, brown, and black, each complemented by matching end caps, for a cohesive and refined look.",
  // 	media: ["/images/shadeinfo/bottombar-options/interlude.jpg"],
  // },

  "Glide Bar": {
    title: "Aluminum Bar",
    body: [
      "Designed exclusively for use with our Aluminum Bar system. This sleek and modern aluminum bar offers a seamless and clean aesthetic, perfectly complementing your window shades. Its internal roller ensures effortless gliding of the banded fabric, providing smooth operation and precise control.",
      "Available in a range of stylish finishes, including white, anodized, linen, brown, and black, with matching end caps.",
    ],
    media: ["/images/shadeinfo/bottombar-options/zero-gravity-interlude.jpg"],
  },
  Illusions: {
    title: "Aluminum Bar",
    body: "The Aluminum bottom bar features a weight adjustment system that ensures an even distribution of weight along the entire width of the shade, resulting in a perfectly level bottom edge and eliminating any unwanted light gaps.",
    media: ["/images/shadeinfo/bottombar-options/illusions.jpg"],
  },
};

const ControlOptions = {
  "Chain Operated": {
    title: "Manual Chain Operation",
    body: [
      "Our chain system offers a seamless and hassle-free experience.",
      "Our chain finishes offer style and functionality:",
      <ul>
        <li>
          Stainless Steel <b>Chain:</b> A sleek, ddurable option that adds a
          touch of modern sophistication.
        </li>

        <li>
          Plastic <b>Chain:</b> Choose from white, linen, grey, brown, and
          black, allowing you to match your shades with your existing decor.
        </li>
      </ul>,
      "All chain operated Roller Shades include the Safety Shield child safety device (b&w only).",
    ],
    // media: ["/videos/shadeinfo/control-options/chain.jpg"],
    media: ["/videos/SS_animation.mp4"],
  },

  "Glide Bar": {
    title: "Manual Chainless Operation",
    body: [
      "Enjoy effortless control with a simple touch, opening or closing the window shade to your desired position.",
      <ul>
        <li>
          <b>Quiet operation:</b> An internal foam layer that covers the
          aluminum shaft, effectively reduces any sound produced during
          operation.
        </li>

        <li>
          <b>Weight balancing:</b> The ZeroGravity™ spring balances the weight
          of the shade, ensuring smooth operation regardless of the fabric size.
          Additionally, the Drive Wheels glide silently and smoothly inside the
          tube.
        </li>
      </ul>,
    ],
    // media: ["/images/shadeinfo/control-options/zero-gravity.jpg"],
    media: ["/videos/ZG_animation.mp4"],
  },

  "Motorized or Automated": {
    title: "Automated Operation",
    body: [
      "Automated control seamlessly combines the functionality of window shades with the convenience of rechargeable technology.",
      <ul>
        <li>
          Operating at speeds of 20, 24, or 28 RPM, Rechargeable ensures smooth
          and quiet adjustments.
        </li>
        <li>
          Versatile power options, including battery or solar panel, providing
          you with flexibility.
        </li>
        <li>
          Control options include remotes, the Bridge, or Zigbee 3.0 for
          effortless management of your window treatment.
        </li>
      </ul>,
    ],
    // media: ["/images/shadeinfo/control-options/motor.jpg"],
    media: ["/videos/Remote_animation.mp4"],
    optionsTitle: "Control Options",
    options: {
      Remotes:
        "Control your Rechargeable Motors effortlessly using user-friendly single channel and 15-channel remote controls.",
      "Smart Connector":
        "Our smart connector let you effortlessly manage your motors using any iOS or Android device, via a WiFi connection. Compatible with Amazon Alexa and Google Home.",
      Wand: "The wand motor system provides each shade with a unified power and control wand, offering a straightforward and cost-effective solution for home automation.",
    },
    actions: [{ to: "/motorized-solutions", text: "Learn More" }],
  },

  Chainless: {
    title: "Chainless",
    body: "Simply pull the shade down to the desired height by the bottom bar.  The shade can easily be retracted by a slight pull of the bottom bar or blind pull.  The shade retracts smoothly thanks to the slow rise speed reducer.",
    media: ["/videos/Chainless_animation.mp4"],
  },
};

const ValanceOptions = {
  "Open Roll": {
    title: "Open Roll",
    body: "Our open roll window shades are designed to seamlessly blend with any décor. If you have window cranks or other obstacles, you can optionally choose a reverse roll configuration.",
    media: ["/images/shadeinfo/valance-options/open-roll.jpg"],
  },
  // "Curved Cassette": {
  // 	title: "Curved Cassette",
  // 	body: [
  // 		"The curved cassette is made of high-quality aluminum and comes in a range of colours with a matte finish.",
  // 		"They have an appealing design on their own, or you can choose to have them covered in the same fabric as the shade, creating a striking window treatment. When wrapped, the fabric fully encompasses the front of the cassettes.",
  // 	],
  // 	media: ["/images/shadeinfo/valance-options/curved_cassette_new.jpg"],
  // },
  "Square Cassette": {
    title: "Square Cassette",
    body: [
      "Get the customization options of the curved cassette in a modern, squared design.",
    ],
    media: ["/images/shadeinfo/valance-options/square-cassette.jpg"],
  },
  "Curved Cassette & Compact Curved Cassette": {
    title: "Curved Cassette & Compact Curved Cassette",
    body: [
      "These cassettes are made of high-quality aluminum and come in a range of colours with a matte finish.",
      "You can choose from the sleek, metal finish or have the front covered in the same fabric as the shade, to create a more seamlessly integrated window treatment.",
    ],
    media: ["/images/shadeinfo/valance-options/curved-cassette-compact.jpg"],
  },

  // "Dual Square Fascia": {
  // 	title: "Dual Square Fascia",
  // 	body: [
  // 		"Our dual shade fascia is designed to work seamlessly with various systems, including chain (equipped with a Safety Shield), Glide Bar, and motorized systems controlled by wireless remotes, switches, or your favorite smart devices.",
  // 		"You have the flexibility to mix and match operation methods for the front and rear shades, tailoring the experience to your preferences.",
  // 	],
  // 	media: ["/images/shadeinfo/valance-options/dual-square-fascia.jpg"],
  // },
  // "Aria Curved Fascia": {
  // 	title: "Snug Curved Fascia",
  // 	body: [
  // 		"The Snug Curved Fascia covers the roller providing a clean and finished look.",
  // 		<ul>
  // 			<li>Clicks into place on the plastic mounting brackets.</li>
  // 			<li>Matching brackets included.</li>
  // 			<li>Available in white and anodized only.</li>
  // 		</ul>,
  // 	],
  // 	media: ["/images/shadeinfo/valance-options/aria-curved-fascia.jpg"],
  // },
  // "Fabric Valance": {
  // 	title: "Fabric Valance",
  // 	body: [
  // 		"The Fabric Valance offers versatile options, including returns for Finish mount applications, and can be tailored to your specifications with custom sizing, all while remaining completely independent from the shade itself, making it a seamless addition to your window treatment ensemble.",
  // 	],
  // 	media: ["/images/shadeinfo/valance-options/fabric-valance.jpg"],
  // },
  // Vision: {
  // 	title: "Vision V84",
  // 	body: "Introducing our sleek square cassette, featuring subtly curved edges for a touch of modern elegance. Each cassette undergoes meticulous assembly, balancing, and testing during manufacturing, guaranteeing optimal performance post-installation. What sets this cassette apart is its innovative floating system, enabling effortless leveling of both the drive and idle ends of the shade after installation. This ingenious feature compensates for any uneven mounting conditions, ensuring a flawless finish in any environment. With attention to detail and unparalleled functionality, our cassette offers both style and reliability for your shading needs.",
  // 	media: ["/images/shadeinfo/valance-options/vision-valance.png"],
  // },
  // "Square Cassette Atlas 2.0": {
  // 	title: "Square Cassette",
  // 	body: "The Square Cassette is a fully enclosed valance system that offer a uniform look for all sides. The cassette system allows for seamless installation with no additional assembly on site. The Square Cassette has reduced light gaps due to its integrated internal brackets. It is available in White, Linen, Anodized, and Black.",
  // 	media: ["/images/shadeinfo/valance-options/square-cassette-atlas2.png"],
  // },
};

const fabricImgPath = (type, fabric, count) =>
  [...Array(count)].map(
    (_, i) =>
      `/images/shadeinfo/fabric-options/${type}/${fabric}${
        count > 1 ? `-${i + 1}` : ""
      }.jpg`,
  );
const FabricOptions = (type = "roller", available = true, count = 1) => ({
  Blackout: {
    title: "Blackout",
    body: [
      "Constructed with multiple layers that prevent light from passing through. Opaque or blackout fabrics can create a nearly pitch-dark environment, making them ideal for bedrooms, home theaters, or any space where complete light control is essential.",
      "The dense layers of materials not only block light but also act as an insulating barrier against heat transfer. This helps maintain a comfortable indoor temperature by reducing heat gain during hot weather and heat loss during colder seasons. As a result, blackout fabrics can contribute to energy efficiency.",
    ],
    media: fabricImgPath(type, "blackout"),
    actions: available
      ? [
          {
            to: `/customize/details?default=${type}&fabric=Blackout`,
            text: "Start Customizing",
            target: "_blank",
          },
        ]
      : [{ to: "/contact", text: "Contact Us For A Quote", target: "_blank" }],
  },
  Privacy: {
    title: "Privacy",
    body: [
      "Privacy window shades are an excellent choice for bedrooms, bathrooms, or any other area where your windows face the street or neighboring properties.",
      "Our collection includes a variety of patterns, solid colors, and textures, to ensure that you can find the perfect fabric that suits your preferences. These fabrics serve a dual purpose by providing privacy while effectively blocking sunlight.",
    ],
    media: fabricImgPath(type, "privacy"),
    actions: available
      ? [
          {
            to: `/customize/details?default=${type}&fabric=Privacy`,
            text: "Start Customizing",
            target: "_blank",
          },
        ]
      : [{ to: "/contact", text: "Contact Us For A Quote", target: "_blank" }],
  },
  Translucent: {
    title: "Translucent",
    body: [
      "These fabrics create a warm and intimate ambiance in your space, allowing the gentle glow of daylight to permeate while maintaining a sense of seclusion.",
      "The light-filtering materials used in these shades soften and diffuse incoming sunlight, creating a gentle, ambient lighting effect. This can help create a more comfortable and inviting atmosphere in your space. At night with the lights on, only silhouettes can be seen from the outside.",
      "Translucent fabrics also help to protect your furniture,  flooring, and other interior elements from fading or discoloration caused by prolonged sun exposure.",
    ],
    media: fabricImgPath(type, "translucent"),
    actions: available
      ? [
          {
            to: `/customize/details?default=${type}&fabric=Translucent`,
            text: "Start Customizing",
            target: "_blank",
          },
        ]
      : [{ to: "/contact", text: "Contact Us For A Quote", target: "_blank" }],
  },
  Sunscreen: {
    title: "Sunscreen",
    body: [
      "With their exceptional UV protection capabilities, these fabrics shield your belongings from the harmful effects of sunrays, ensuring long-lasting beauty and durability.",
      "Sunscreen fabrics excel at reducing the discomfort caused by intense sunlight, allowing you to enjoy a bright and inviting space while maintaining optimal visibility.",
      "They also contribute to energy efficiency by regulating the temperature in your space.",
    ],
    media: fabricImgPath(type, "sunscreen"),
    actions: available
      ? [
          {
            to: `/customize/details?default=${type}&fabric=Sunscreen`,
            text: "Start Customizing",
            target: "_blank",
          },
        ]
      : [{ to: "/contact", text: "Contact Us For A Quote", target: "_blank" }],
  },
  Transparent: {
    title: "Transparent",
    body: [
      "Our extensive range of see-through fabrics provides a wide array of choices for decorating purposes. Our collection includes linen, textured, sunscreen-like fabrics, all of which offer clear views to the outside and a gentle diffusion of natural light.",
      "These fabrics are particularly ideal for windows facing the north, as they allow ample natural light to enter. Moreover, they beautifully harmonize with drapes or curtains, as a sleek alternative to sheer curtains.",
    ],
    media: fabricImgPath(type, "transparent"),
    actions: available
      ? [
          {
            to: `/customize/details?default=${type}&fabric=Transparent`,
            text: "Start Customizing",
            target: "_blank",
          },
        ]
      : [{ to: "/contact", text: "Contact Us For A Quote", target: "_blank" }],
  },
  "Day & Night": {
    title: "Day And Night",
    body: [
      "Day and Night Cellular Shades are crafted to adapt to your lifestyle. These shades feature a unique dual-layer design, combining light-filtering and room-darkening fabrics in a single shade, giving you full control over the light levels in your space.",
      "During the day, enjoy softly diffused natural light with the light-filtering fabric, creating a bright and welcoming atmosphere while preserving privacy. When you need restful darkness or extra insulation, simply adjust to the room-darkening fabric for a cozy, private setting. These shades are ideal for bedrooms, living rooms, and home offices, offering flexibility and energy efficiency year-round.",
    ],
    media: fabricImgPath(type, "daynight"),
    actions: available
      ? [
          {
            to: `/customize/details?default=${type}&fabric=Transparent`,
            text: "Start Customizing",
            target: "_blank",
          },
        ]
      : [{ to: "/contact", text: "Contact Us For A Quote", target: "_blank" }],
  },
  "Light Filtering": {
    title: "Light Filtering",
    body: [
      "Light Filtering window shades are an excellent choice for bedrooms, bathrooms, or any other area where your windows face the street or neighboring properties.",
      "Our collection includes a variety of patterns, solid colors, and textures, to ensure that you can find the perfect fabric that suits your preferences. These fabrics serve a dual purpose by providing privacy while effectively blocking sunlight.",
    ],
    media: fabricImgPath(type, "privacy"),
    actions: available
      ? [
          {
            to: `/customize/details?default=${type}&fabric=Privacy`,
            text: "Start Customizing",
            target: "_blank",
          },
        ]
      : [{ to: "/contact", text: "Contact Us For A Quote", target: "_blank" }],
  },
});

const shadeTypeDetails = {
  roller: {
    metaTitle:
      "Roller Shades & Blinds: Best Blackout Roller Window Shades | Off Cut Shades",
    metaDesc:
      "Best roller shades & blinds in Canada with Off Cut Shades. Providing custom roller shades for windows at low prices in the most popular fabrics.",
    hero: {
      header: "Roller Shades",
      body: "Our roller shades are more than just window coverings; they are a reflection of your taste and personality. Our easy-to-use roller shade systems. Effortlessly adjust light and privacy.",
      // "Unlock unparalleled performance  with our wide array of valance options, featuring fascia and cassettes. Immerse yourself in our innovative product lineup, and elevate your shading experience to new heights of reliability and style.",
      img: "/images/shadeinfo/shadecard/roller.jpg",
      to: "roller",
      //price: "$144 - $190 CAD",
      price: 198,
      discount: shadeTypeDiscount,
      //discountPrice: "$50 - $95 CAD",
      discountPrice: "$54 - $443 CAD",
      actions: [{ to: "/motorized-solutions", text: "Learn more" }],
    },
    "Control Options": [
      ControlOptions["Chain Operated"],
      ControlOptions["Glide Bar"],
      ControlOptions["Motorized or Automated"],
    ],
    "Valance Options": [
      ValanceOptions["Open Roll"],
      // ValanceOptions["Square Fascia"],
      ValanceOptions["Square Cassette"],
      ValanceOptions["Curved Cassette & Compact Curved Cassette"],
    ],
    "Bottom Bar Options": [
      BottomBarOptions["Aluminum Hem"],
      // BottomBarOptions["Plain Hem"],
    ],
    "Fabric Options": [
      FabricOptions("roller")["Blackout"],
      FabricOptions("roller")["Privacy"],
      // FabricOptions("roller")["Translucent"],
      FabricOptions("roller")["Sunscreen"],
      FabricOptions("roller")["Transparent"],
    ],
    Gallery: [
      "/images/shadeinfo/shades/roller/1.jpg",
      "/images/shadeinfo/shades/roller/2.jpg",
      "/images/shadeinfo/shades/roller/3.jpg",
      "/images/shadeinfo/shades/roller/4.jpg",
      "/images/shadeinfo/shades/roller/5.jpg",
      "/images/shadeinfo/shades/roller/6.jpg",
      "/images/shadeinfo/shades/roller/7.jpg",
      "/images/shadeinfo/shades/roller/8.jpg",
      "/images/shadeinfo/shades/roller/9.jpg",
      "/images/shadeinfo/shades/roller/10.jpg",
    ],
    // 'Order Shades': {
    //   title: 'Shop',
    //   available: true,
    //   img: '/images/about/showroom.jpg',
    // },
    actions: [
      {
        to: `/customize/details?default=roller&fabric=all`,
        text: "Start Customizing",
      },
    ],
  },

  zebra: {
    metaTitle:
      "Zebra Shades & Blinds: Best Custom Banded Window Shades | Off Cut Shades",
    metaDesc:
      "Best zebra shades & blinds in Canada with Off Cut Shades. Providing custom banded shades for windows at low prices in the most popular fabrics.",
    hero: {
      header: "Zebra Shades",
      body: "Zebra shades seamlessly integrate transparent fabric with either blackout, privacy or transparent vanes, granting you complete control over privacy and light. With vanes gracefully cascading around the system, you can create the ideal lighting and ambiance for any space.",
      img: "/images/shadeinfo/shadecard/banded.jpg",
      to: "banded",
      price: 262.5,
      discount: shadeTypeDiscount,
      discountPrice: "$66 - $330 CAD",
    },
    "Control Options": [
      ControlOptions["Chain Operated"],
      ControlOptions["Glide Bar"],
      ControlOptions["Motorized or Automated"],
    ],
    "Valance Options": [
      ValanceOptions["Curved Cassette & Compact Curved Cassette"],
      ValanceOptions["Square Cassette"],
    ],
    "Bottom Bar Options": [
      BottomBarOptions["Glide Bar"],
      // BottomBarOptions["Banded Bar"],
    ],
    "Fabric Options": [
      FabricOptions("banded", true, 2)["Blackout"],
      FabricOptions("banded", true, 2)["Privacy"],
      // FabricOptions("banded", true, 2)["Translucent"],
      FabricOptions("banded", true, 2)["Transparent"],
    ],
    Gallery: [
      "/images/shadeinfo/shades/banded/1.jpg",
      "/images/shadeinfo/shades/banded/2.jpg",
      "/images/shadeinfo/shades/banded/3.jpg",
      "/images/shadeinfo/shades/banded/4.jpg",
      "/images/shadeinfo/shades/banded/5.jpg",
      "/images/shadeinfo/shades/banded/6.jpg",
      "/images/shadeinfo/shades/banded/7.jpg",
      "/images/shadeinfo/shades/banded/8.jpg",
      "/images/shadeinfo/shades/banded/9.jpg",
    ],
    // 'Order Shades': {
    //   title: 'Shop',
    //   available: true,
    //   img: '/images/about/showroom.jpg',
    // },
    actions: [
      {
        to: `/customize/details?default=zebra&fabric=all`,
        text: "Start Customizing",
      },
    ],
  },

  sheer: {
    metaTitle: "Sheer Shades: Best Custom Sheer Window Shades | Off Cut Shades",
    metaDesc:
      "Best sheer shades in Canada with Off Cut Shades. Providing custom sheer shades for windows at low prices in the most popular fabrics.",
    hero: {
      header: "Sheer Shades",
      body: "Our sheer shades provide complete control over privacy and light. With a simple tilt of the vanes, you can adjust the balance of natural light.",
      img: "/images/shadeinfo/shadecard/sheer.jpg",
      to: "sheer",
      price: 416.5,
      discount: shadeTypeDiscount,
      discountPrice: "$148 CAD",
    },
    "Control Options": [
      ControlOptions["Chain Operated"],
      ControlOptions["Motorized or Automated"],
    ],
    "Valance Options": [
      ValanceOptions["Square Cassette"],
      ValanceOptions["Curved Cassette & Compact Curved Cassette"],
    ],
    "Bottom Bar Options": [BottomBarOptions["Illusions"]],
    "Fabric Options": [
      FabricOptions("sheer")["Blackout"],
      FabricOptions("sheer")["Privacy"],
    ],
    Gallery: [
      "/images/shadeinfo/shades/sheer/1.jpg",
      "/images/shadeinfo/shades/sheer/2.jpg",
      "/images/shadeinfo/shades/sheer/3.jpg",
      "/images/shadeinfo/shades/sheer/4.jpg",
    ],
    // 'Order Shades': {
    //   title: 'Shop',
    //   available: true,
    //   img: '/images/about/showroom.jpg',
    // },
    actions: [
      {
        to: `/customize/details?default=sheer&fabric=all`,
        text: "Start Customizing",
        target: "_blank",
      },
    ],
  },

  aria: {
    metaTitle:
      "Snug Shades & Blinds: Best Custom Snug Window Shades | Off Cut Shades",
    metaDesc:
      "Best snug shades & blinds in Canada with Off Cut Shades. Providing custom snug shades for windows at low prices in the most popular fabrics.",
    hero: {
      header: "Snug Shades",
      body: "Snug's universal mounting bracket installs easily in both wall & ceiling mount applications. Simply set your Snug shade on the pin, the other end slides in and locks in your Snug shade with a click. The Snug valance goes on in a snap.",
      img: "/images/shadeinfo/shadecard/aria.jpg",
      to: "aria",
    },
    "Control Options": [ControlOptions["Chainless"]],
    "Valance Options": [ValanceOptions["Aria Curved Fascia"]],
    "Bottom Bar Options": [
      BottomBarOptions["Aluminum Hem"],
      // BottomBarOptions["Plain Hem"],
    ],
    "Fabric Options": [
      FabricOptions("roller")["Blackout"],
      FabricOptions("roller")["Privacy"],
      // FabricOptions("roller")["Translucent"],
      FabricOptions("roller")["Sunscreen"],
      FabricOptions("roller")["Transparent"],
    ],
    Gallery: [
      "/images/shadeinfo/shades/aria/1.jpg",
      "/images/shadeinfo/shades/aria/2.jpg",
    ],
    // 'Order Shades': {
    //   title: 'Contact Us For A Quote',
    //   available: false,
    //   img: '/images/about/showroom.jpg',
    // },
    actions: [
      {
        to: `/contact`,
        text: "Contact Us For A Quote",
      },
    ],
    contactUs: "CONTACT US FOR QUOTE",
  },

  atlas: {
    metaTitle:
      "Bottom Up Shades: Best Custom Bottom Up Shades & Blinds | Off Cut Shades",
    metaDesc:
      "Best bottom up shades in Canada with Off Cut Shades. Providing custom bottom up shades & blinds for windows at low prices in the most popular fabrics.",
    hero: {
      header: "Bottom Up Shades",
      body: "By simply inverting the roller shade, Bottom Up Shade finds new harmony and balance between daylight and personal privacy. Covering windows from the bottom up obscures sight lines, and the top opening permits the warmth and radiance of natural light.",
      img: "/images/shadeinfo/shadecard/atlas.png",
      to: "atlas",
    },
    "Control Options": [ControlOptions["Motorized or Automated"]],

    "Valance Options": [ValanceOptions["Square Cassette Atlas 2.0"]],
    "Bottom Bar Options": [BottomBarOptions["Aluminum Hem"]],
    "Fabric Options": [
      FabricOptions("roman", false)["Blackout"],
      FabricOptions("roman", false)["Privacy"],
      // FabricOptions("roman", false)["Translucent"],
      FabricOptions("roman", false)["Sunscreen"],
      FabricOptions("roman", false)["Transparent"],
    ],
    Gallery: [
      "/images/shadeinfo/shades/roman/1.jpg",
      "/images/shadeinfo/shades/roman/2.jpg",
      "/images/shadeinfo/shades/roman/3.jpg",
      "/images/shadeinfo/shades/roman/4.jpg",
      "/images/shadeinfo/shades/roman/5.jpg",
      "/images/shadeinfo/shades/roman/6.jpg",
    ],
    // 'Order Shades': {
    //   title: 'Contact Us For A Quote',
    //   available: false,
    //   img: '/images/about/showroom.jpg',
    // },
    actions: [
      // {
      //   to: `/contact`,
      //   text: 'GET QUOTE',
      //   target: '_blank',
      // },
      {
        to: `/contact`,
        text: "Contact Us For A Quote",
      },
    ],
    contactUs: "CONTACT US FOR QUOTE",
  },

  roman: {
    hero: {
      header: "Roman Shades",
      body: "Soft fabrics create cascading folds as the shade is raised for a rich and luscious yet classical look that has been popular through the ages. As the name suggests, Roman shades have been decorating windows for over 2000 years.",
      img: "/images/shadeinfo/shadecard/roman.png",
      to: "roller",
    },
    "Control Options": [
      ControlOptions["Chain Operated"],
      ControlOptions["Motorized or Automated"],
    ],

    "Valance Options": [ValanceOptions["Fabric Valance"]],
    "Bottom Bar Options": [
      BottomBarOptions["Aluminum Hem"],
      // BottomBarOptions["Plain Hem"],
    ],
    "Fabric Options": [
      FabricOptions("roman", false)["Blackout"],
      FabricOptions("roman", false)["Privacy"],
      // FabricOptions("roman", false)["Translucent"],
      FabricOptions("roman", false)["Sunscreen"],
      FabricOptions("roman", false)["Transparent"],
    ],
    Gallery: [
      "/images/shadeinfo/shades/roman/1.jpg",
      "/images/shadeinfo/shades/roman/2.jpg",
      "/images/shadeinfo/shades/roman/3.jpg",
      "/images/shadeinfo/shades/roman/4.jpg",
      "/images/shadeinfo/shades/roman/5.jpg",
      "/images/shadeinfo/shades/roman/6.jpg",
    ],
    // 'Order Shades': {
    //   title: 'Contact Us For A Quote',
    //   available: false,
    //   img: '/images/about/showroom.jpg',
    // },
    actions: [
      // {
      //   to: `/contact`,
      //   text: 'GET QUOTE',
      //   target: '_blank',
      // },
      {
        to: `/contact`,
        text: "Contact Us For A Quote",
      },
    ],
    contactUs: "CONTACT US FOR QUOTE",
  },

  dual: {
    metaTitle:
      "Dual Roller Shades: Best Custom Dual Roller Window Shades | Off Cut Shades",
    metaDesc:
      "Best dual roller shades in Canada with Off Cut Shades. Providing custom roller shades for windows at low prices in the most popular fabrics.",
    hero: {
      header: "Dual Shades",
      body: "The ultimate no compromise option for people that want the most out of their shades, our Dual Shades provide incredible privacy, light, and view control. Create distinct looks with complimentary colours and textures, and enjoy the freedom of a wide range of control options.",
      img: "/images/shadeinfo/shadecard/dual.jpg",
      to: "roller",
    },
    "Control Options": [
      ControlOptions["Chain Operated"],
      ControlOptions["Glide Bar"],
      ControlOptions["Motorized or Automated"],
    ],
    "Valance Options": [ValanceOptions["Dual Square Fascia"]],
    "Bottom Bar Options": [
      BottomBarOptions["Aluminum Hem"],
      // BottomBarOptions["Plain Hem"],
    ],
    "Fabric Options": [
      FabricOptions("roller", false)["Blackout"],
      FabricOptions("roller", false)["Privacy"],
      // FabricOptions("roller", false)["Translucent"],
      FabricOptions("roller", false)["Sunscreen"],
      FabricOptions("roller", false)["Transparent"],
    ],
    Gallery: [
      "/images/shadeinfo/shades/dual/1.jpg",
      "/images/shadeinfo/shades/dual/2.jpg",
      "/images/shadeinfo/shades/dual/3.jpg",
      "/images/shadeinfo/shades/dual/4.jpg",
      "/images/shadeinfo/shades/dual/5.jpg",
    ],
    // 'Order Shades': {
    //   title: 'Contact Us For A Quote',
    //   available: false,
    //   img: '/images/about/showroom.jpg',
    // },
    actions: [
      // {
      //   to: `/contact`,
      //   text: 'GET QUOTE',
      //   target: '_blank',
      // },
      {
        to: `/contact`,
        text: "Contact Us For A Quote",
      },
    ],
    contactUs: "CONTACT US FOR QUOTE",
  },

  panel_track: {
    metaTitle:
      "Panel Track Shades: Best Custom Panel Track Shades & Blinds | Off Cut Shades",
    metaDesc:
      "Best panel track shades in Canada with Off Cut Shades. Providing custom panel track shades & blinds for windows at low prices in the most popular fabrics.",
    hero: {
      header: "Panel Track Shades",
      body: "Make an impression with the bold and dramatic panel track shade. Panels of fabric glide along a track, splitting from the center or either side for theatrical décor that's perfect for large windows, patio doors, or even for dividing large rooms.",
      img: "/images/shadeinfo/shadecard/panel.jpg",
      to: "roller",
    },
    "Control Options": [
      ControlOptions["Chain Operated"],
      ControlOptions["Motorized or Automated"],
    ],
    "Valance Options": [ValanceOptions["Fabric Valance"]],
    "Bottom Bar Options": [
      BottomBarOptions["Aluminum Hem"],
      // BottomBarOptions["Plain Hem"],
    ],
    "Fabric Options": [
      FabricOptions("roller", false)["Blackout"],
      FabricOptions("roller", false)["Privacy"],
      // FabricOptions("roller", false)["Translucent"],
      FabricOptions("roller", false)["Sunscreen"],
      FabricOptions("roller", false)["Transparent"],
    ],
    Gallery: [
      "/images/shadeinfo/shades/panel-track/1.jpg",
      "/images/shadeinfo/shades/panel-track/2.jpg",
      "/images/shadeinfo/shades/panel-track/3.jpg",
      "/images/shadeinfo/shades/panel-track/4.jpg",
    ],
    // 'Order Shades': {
    //   title: 'Contact Us For A Quote',
    //   available: false,
    //   img: '/images/about/showroom.jpg',
    // },
    actions: [
      // {
      //   to: `/contact`,
      //   text: 'GET QUOTE',
      //   target: '_blank',
      // },
      {
        to: `/contact`,
        text: "Contact Us For A Quote",
      },
    ],
    contactUs: "CONTACT US FOR QUOTE",
  },
  cellular: {
    metaTitle:
      "Cellular Shades: Best Custom Day & Night Shades | Off Cut Shades",
    metaDesc:
      "Best custom shades in Canada with Off Cut Shades. Providing custom day and night shades & blinds for windows at low prices in the most popular fabrics.",
    hero: {
      header: "Cellular Shades",
      body: "Experience the perfect blend of style and functionality with our advanced cellular shades. These shades offer superior protection against harmful UV rays, preserving the vibrancy of your interior furnishings. The honeycomb shape of the fabric cells have excellent insulating properties, reducing heat loss in the winter and heat absorption in the summer, lowering your energy costs. In addition, external noise is minimized, ensuring a serene and comfortable atmosphere. Crafted from high-quality, anti-static dust resistant fabrics, our shades maintain their pristine appearance.",
      img: "/images/newHome/shades/cellular.jpg",
      to: "cellular",
    },
    "Control Options": [],
    "Valance Options": [],
    "Bottom Bar Options": [],
    "Fabric Options": [
      FabricOptions("cellular", false)["Blackout"],
      FabricOptions("cellular", false)["Privacy"],
      FabricOptions("cellular", false)["Day & Night"],
    ],
    Gallery: ["/images/newHome/shades/cellular.jpg"],

    actions: [
      {
        to: `/contact`,
        text: "Contact Us For A Quote",
      },
    ],
    contactUs: "CONTACT US FOR QUOTE",
  },

  simply_cellular: {
    metaTitle:
      "Simply Cellular Shades: Best Custom Day & Night Shades | Off Cut Shades",
    metaDesc:
      "Best custom shades in Canada with Off Cut Shades. Providing custom day and night shades & blinds for windows at low prices in the most popular fabrics.",
    hero: {
      header: "Simply Cellular Shades",
      body: "Our simply cellular shades combine elegant design with energy-saving insulation. The honeycomb structure blocks UV rays to protect furniture, reduces heating/cooling costs, and minimizes noise while staying clean with dust-resistant fabric.",
      img: "/images/newHome/shades/cellular.jpg",
      to: "simply-cellular",
      price: 184.5,
    },
    "Control Options": [],
    "Valance Options": [],
    "Bottom Bar Options": [],
    "Fabric Options": [
      FabricOptions("cellular", false)["Day & Night"],
      FabricOptions("cellular", false)["Light Filtering"],
      FabricOptions("cellular", false)["Blackout"],
    ],
    Gallery: ["/images/newHome/shades/cellular.jpg"],
    actions: [
      {
        to: `/customize/details?default=simply_cellular&fabric=all`,
        text: "Start Customizing",
        target: "_blank",
      },
    ],
  },
  vertical_sheer: {
    metaTitle:
      "Vertical Sheer Shades: Best Custom Vertical Sheer Shades | Off Cut Shades",
    metaDesc:
      "Best custom vertical sheer shades in Canada with Off Cut Shades. Providing custom vertical sheer shades & blinds for windows at low prices in the most popular fabrics.",
    hero: {
      header: "Vertical Sheer Shades",
      body: "Vertical sheer shades combine the elegance of sheer fabrics with the functionality of vertical blinds. These shades allow you to control light and privacy while adding a touch of sophistication to your space. The vertical orientation provides excellent coverage for large windows and sliding doors, making them a versatile choice for various room styles.",
      img: "/images/newHome/shades/vertical_sheer.jpg",
      to: "vertical-sheer",
      price: 262.5,
    },
    "Control Options": [],
    "Valance Options": [],
    "Bottom Bar Options": [],
    "Fabric Options": [
      FabricOptions("vertical_sheer", false)["Blackout"],
      FabricOptions("vertical_sheer", false)["Privacy"],
    ],
    Gallery: ["/images/newHome/shades/vertical-sheer.jpg"],
    actions: [
      {
        to: `/customize/details?default=vertical_sheer&fabric=all`,
        text: "Start Customizing",
        target: "_blank",
      },
    ],
  },
};

const shadeMetaDetails = {
  living_room_window_shades: {
    metaTitle:
      "Living Room Shades: Custom Living Room Window Shades | Off Cut Shades",
    metaDesc:
      "Custom window shades for living rooms by Off Cut Shades. Order living room shades at the best prices online, 2-day shipping across Canada.",
    content: [
      {
        title: "Living Room Shades: Custom Window Shades For Living Rooms",
        body: "At Off Cut Shades, we specialize in custom window shades designed specifically for living rooms, enhancing both the aesthetic and functionality of your space. Tailoring solutions to fit your personal style and needs, we provide an array of shades perfect for any living room setup. Our custom shades not only offer privacy but also control unwanted light, ensuring your living area remains comfortable and stylish.",
        media: {
          type: "Living Room Shades",
          alt: "Living Room Shades",
          src: "/images/lifestyle/new/living_room_shades.jpg",
        },
      },
      {
        title: "Vertical Sheer Shades For Living Rooms",
        body: "Vertical sheer shades are an elegant choice for living rooms, combining the beauty of sheer fabrics with the practicality of vertical blinds. These shades allow you to control light and privacy while adding a touch of sophistication to your space. The vertical orientation provides excellent coverage for large windows and sliding doors, making them a versatile choice for various room styles.",
        media: {
          type: "Vertical Sheer Shades",
          alt: "Living Room Vertical Sheer Shades",
          src: "/images/newHome/shades/vertical_sheer.jpg",
        },
      },
      {
        title: "Shades We Offer For Living Rooms",
        body: "Off Cut Shades crafts a variety of living room window treatments to meet the diverse preferences of our customers. Our selection includes Roller, Zebra/Banded, Sheer, Snug, Bottom Up, Dual, and Panel Track shades, all of which are designed to provide both function and fashion to your living room windows. Each type caters to different aesthetics from modern window shades to traditional designs, accommodating a wide range of window sizes, including huge windows.",
      },
      {
        title: "Roller",
        body: "Our Roller shades for living room windows are sleek and straightforward, ideal for achieving a minimalist or modern look. These shades are effective in blocking out unwanted light and can be customized with a privacy liner to ensure your living space remains your own sanctuary. Roller shades are a popular choice among homeowners looking for clean lines and ease of use.",
        media: {
          type: "Roller Shades",
          alt: "Living Room Roller Shades",
          src: "/images/shadeinfo/shades/roller/1.jpg",
        },
        actions: [
          {
            text: "Explore",
            to: `/shop/info/roller`,
          },
        ],
      },
      {
        title: "Zebra / Banded",
        body: "Zebra or Banded shades offer a striking alternative, featuring alternating sheer and opaque bands of fabric. This design allows you to adjust the shades to create light effects and privacy levels that suit your moment-to-moment needs. Zebra shades are perfect for adding a touch of sophistication to any living room, blending seamlessly with both contemporary and traditional decors.",
        media: {
          type: "Zebra/Banded Shades",
          alt: "Living Room Zebra Shades",
          src: "/images/shadeinfo/shades/banded/1.jpg",
        },
        actions: [
          {
            text: "Explore",
            to: `/shop/info/zebra`,
          },
        ],
      },
      {
        title: "Sheer",
        body: "Sheer shades are an elegant option for those who prefer a gentle infusion of natural light while still protecting privacy. These shades diffuse sunlight, softening the incoming light and creating a warm, inviting atmosphere in your living room. Ideal for settings where you want to avoid the harshness of direct sunlight but cherish a bright, airy feel.",
        media: {
          type: "Sheer Shades",
          alt: "Living Room Sheer Shades",
          src: "/images/shadeinfo/shades/sheer/1.jpg",
        },
        actions: [
          {
            text: "Explore",
            to: `/shop/info/sheer`,
          },
        ],
      },
      {
        title: "Snug",
        body: "Snug shades are tailored to fit perfectly within the window frame, offering a precise and clean appearance. These are particularly effective in living rooms with unique window sizes or shapes, ensuring no gaps that might allow light leaks. Snug shades are the go-to choice for a polished look that complements the existing décor without overwhelming it.",
        media: {
          type: "Snug Shades",
          alt: "Living Room Snug Shades",
          src: "/images/shadeinfo/shades/aria/1.jpg",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Bottom Up",
        body: "Bottom Up shades are designed to offer versatility and control. These shades can be raised from the bottom to allow light in while maintaining privacy at eye level, making them perfect for street-level living rooms or areas where you need controlled visibility. They provide a practical solution for managing visibility and light in your living area.",
        media: {
          type: "Bottom Up Shades",
          alt: "Living Room Bottom Up Shades",
          src: "/images/shadeinfo/shades/atlas/1.png",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Dual",
        body: "Dual shades combine the functionality of two different shade types in one. This allows you to switch between light-filtering and blackout options, providing ultimate control over light and privacy. Whether you want to illuminate your living room during the day or ensure complete darkness for movie nights, Dual shades offer the flexibility you need.",
        media: {
          type: "Dual Shades",
          alt: "Living Room Dual Shades",
          src: "/images/shadeinfo/shades/dual/1.jpg",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Panel Track",
        body: "Panel Track shades are ideal for larger living room windows or glass doors. These shades glide smoothly along a track, offering a sleek and contemporary look. They are excellent for managing light in rooms with wide windows or for dividing spaces within larger areas, adding both function and style to your living room.",
        media: {
          type: "Panel Track Shades",
          alt: "Living Room Panel Track Shades",
          src: "/images/shadeinfo/shades/panel-track/1.jpg",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Fabrics For Custom Living Room Shades",
        body: "At Off Cut Shades, we understand that the choice of fabric is crucial for achieving the desired functionality and aesthetic of your living room shades. We offer a variety of fabrics including Transparent, Sunscreen, Translucent, and Privacy options, each tailored to meet specific needs from light filtering to complete light blockage.",
      },
      {
        title: "Transparent",
        body: "Transparent fabrics are perfect for living rooms where maximizing natural light is desired without sacrificing a tailored look. These fabrics allow you to enjoy the view outside while softly filtering the daylight, enhancing the room's natural brightness without the harshness.",
        media: {
          type: "Transparent Fabric",
          alt: "Transparent Fabric For Living Room Shades",
          src: "/images/shadeinfo/fabric/transparent/1.png",
        },
      },
      {
        title: "Sunscreen",
        body: "Sunscreen fabrics are engineered to provide UV protection while allowing light to enter the room. This makes them ideal for living rooms that receive a lot of sun, helping to protect your furniture from fading while still enjoying the benefits of natural light.",
        media: {
          type: "Sunscreen Fabric",
          alt: "Sunscreen Fabric For Living Room Shades",
          src: "/images/shadeinfo/fabric/sunscreen/1.png",
        },
      },
      {
        title: "Translucent",
        body: "Translucent fabrics offer a superb balance between privacy and natural light. These fabrics obscure the view into your home while still allowing light to pass through, perfect for those who value privacy but do not want to compromise on the room’s luminosity.",
        media: {
          type: "Translucent Fabric",
          alt: "Translucent Fabric For Living Room Shades",
          src: "/images/shadeinfo/fabric/translucent/1.png",
        },
      },
      {
        title: "Privacy",
        body: "Privacy fabrics are designed to shield your living room from outside eyes, providing a high level of privacy while still allowing some light to filter through. These are ideal for homes in densely populated areas or for anyone who prioritizes seclusion and tranquility.",
        media: {
          type: "Privacy Fabric",
          alt: "Privacy Fabric For Living Room Shades",
          src: "/images/shadeinfo/fabric/privacy/1.png",
        },
      },
      {
        title: "Why Choose Off Cut Shades For Living Room Shades",
        body: "Off Cut Shades is the choice for custom living room shades. We offer a 5-year warranty, a satisfaction guarantee, free shipping within 2 days, and all our shades are meticulously handcrafted in Canada. Our commitment to quality and customer satisfaction ensures that you find the perfect window treatment solutions for your home.",
      },
      {
        title: "Find the Perfect Windows Shades For Your Living Room",
        body: "Choosing the right shades for your living room is straightforward with Off Cut Shades. You can easily order custom living room shades directly online, tailored to fit your specific needs and style preferences. Our user-friendly website allows you to select from a wide range of fabrics and styles, ensuring that you find the ideal window treatments to enhance your living space.",
        actions: [
          {
            text: "Get Started",
            to: "/shop",
          },
        ],
      },
    ],
  },
  bedroom_window_shades: {
    metaTitle: "Bedroom Shades: Custom Bedroom Window Shades | Off Cut Shades",
    metaDesc:
      "Custom window shades for bedrooms by Off Cut Shades. Order bedroom shades at the best prices online, 2-day shipping across Canada.",
    content: [
      {
        title: "Bedroom Shades: Custom Window Shades For Bedrooms",
        body: "Bedroom shades are essential for creating a personal haven that combines style, privacy, and control over incoming light. At Off Cut Shades, we specialize in providing custom window shades tailored specifically for bedroom environments. Our bespoke solutions ensure that you can achieve the perfect ambiance, whether that's complete darkness for undisturbed sleep or a softly lit room using light-filtering shades. From the selection of materials to the final installation, we guarantee a product that not only enhances your space but also embodies precision and quality.",
        media: {
          type: "Bedroom Shades",
          alt: "Bedroom Shades",
          src: "/images/lifestyle/new/bedroom_shades.jpg",
        },
      },
      {
        title: "Shades We Offer For Bedrooms",
        body: "Off Cut Shades offers a diverse range of bedroom window shades to cater to different aesthetic and functional needs. Our variety includes Roller, Zebra/Banded, Sheer, Snug, Bottom Up, Dual, and Panel Track shades, each designed to enhance the functionality of shades in your bedroom. Whether you need blackout shades for complete darkness or solar shades for gradual light control, our options provide both style and functionality, ensuring your bedroom is equipped for both comfort and privacy.",
      },
      {
        title: "Roller",
        body: "Roller shades by Off Cut Shades are a sleek and practical choice for bedroom window treatments. Known for their ease of use and versatility, these shades are perfect for achieving varying degrees of light control. Available in a wide range of fabrics, including blackout options, roller shades ensure you can block out unwanted light for a restful night or allow just enough light to gently wake you in the morning.",
        media: {
          type: "Roller Shades",
          alt: "Bedroom Roller Shades",
          src: "/images/shadeinfo/shades/roller/1.jpg",
        },
        actions: [
          {
            text: "Explore",
            to: `/shop/info/roller`,
          },
        ],
      },
      {
        title: "Zebra / Banded",
        body: "Zebra or Banded shades offer a modern twist to classic roller shades, featuring alternating sheer and opaque bands. These shades allow for excellent light control while adding a striking visual element to your bedroom. Adjust the bands to transition seamlessly from complete privacy to a beautiful, diffused light setting, enhancing both the aesthetics and functionality of your bedroom.",
        media: {
          type: "Zebra/Banded Shades",
          alt: "Bedroom Zebra Shades",
          src: "/images/shadeinfo/shades/banded/1.jpg",
        },
        actions: [
          {
            text: "Explore",
            to: `/shop/info/zebra`,
          },
        ],
      },
      {
        title: "Sheer",
        body: "Sheer shades are ideal for those who love to wake up to natural light while still requiring a degree of privacy. Our sheer shades softly filter incoming light, creating a warm and inviting atmosphere in the bedroom. They are perfect for setting a relaxing mood, allowing gentle light to fill the room without the harshness of direct sunlight.",
        media: {
          type: "Sheer Shades",
          alt: "Bedroom Sheer Shades",
          src: "/images/shadeinfo/shades/sheer/1.jpg",
        },
        actions: [
          {
            text: "Explore",
            to: `/shop/info/sheer`,
          },
        ],
      },
      {
        title: "Snug",
        body: "Snug shades are tailored to fit perfectly within your window frame, providing a clean and minimalistic look. These shades are particularly effective in bedrooms where space is at a premium or where a flush window treatment is desired. Snug shades can be crafted in light-filtering or blackout materials, giving you the flexibility to choose the level of privacy and light control you prefer.",
        media: {
          type: "Snug Shades",
          alt: "Bedroom Snug Shades",
          src: "/images/shadeinfo/shades/aria/1.jpg",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Bottom Up",
        body: "Bottom Up shades from Off Cut Shades offer a unique approach to privacy and light control. These shades can be raised from the bottom, allowing light to enter while still covering the lower part of the window, maintaining privacy. This feature is particularly beneficial in bedrooms, where you might want privacy without sacrificing natural light.",
        media: {
          type: "Bottom Up Shades",
          alt: "Bedroom Bottom Up Shades",
          src: "/images/shadeinfo/shades/atlas/1.png",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Dual",
        body: "Dual shades provide the ultimate flexibility in light control and privacy options for bedroom shades. At Off Cut Shades, our dual shades combine two layers of fabric, which can be adjusted independently to achieve varying levels of opacity and light filtration. This versatility makes dual shades a popular choice for bedrooms, as they allow for complete customization of light and privacy according to your needs throughout the day.",
        media: {
          type: "Dual Shades",
          alt: "Bedroom Dual Shades",
          src: "/images/shadeinfo/shades/dual/1.jpg",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Panel Track",
        body: "Panel Track shades are an elegant solution for larger bedroom windows or sliding doors. These shades glide smoothly along a track and can be layered to create varying light effects and privacy levels. The wide panels provide substantial coverage and can be pulled back to reveal stunning views, making them not only functional but also a statement piece in any bedroom.",
        media: {
          type: "Panel Track Shades",
          alt: "Bedroom Panel Track Shades",
          src: "/images/shadeinfo/shades/panel-track/1.jpg",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Fabrics For Custom Bedroom Shades",
        body: "Choosing the right fabric is crucial for achieving the desired functionality and aesthetic in your bedroom. Off Cut Shades offers a selection of fabrics that cater to various needs, including Privacy and Blackout materials. Each fabric type serves a specific purpose, from preserving a view with transparent fabrics to ensuring total darkness with blackout materials. Our fabrics are carefully selected to ensure durability and performance, complementing the wide range of shades we offer.",
      },
      {
        title: "Privacy",
        body: "Privacy fabrics are designed to obstruct the view into your bedroom while allowing some light to pass through. These fabrics are perfect for those who prioritize privacy but still appreciate the ambient light that enhances the comfort and warmth of the bedroom.",
        media: {
          type: "Privacy Fabric",
          alt: "Privacy Fabric For Bedroom Shades",
          src: "/images/shadeinfo/fabric/privacy/1.png",
        },
      },
      {
        title: "Blackout",
        body: "Blackout fabrics are essential for those who need complete darkness to ensure a good night's sleep. Our blackout window shades block all incoming light, creating an ideal sleeping environment. This fabric is perfect for shift workers, parents of young children, or anyone sensitive to light during sleeping hours.",
        media: {
          type: "Blackout Fabric",
          alt: "Blackout Fabric For Bedroom Shades",
          src: "/images/shadeinfo/fabric/blackout/1.png",
        },
      },
      {
        title: "Why Choose Off Cut Shades For Bedroom Shades",
        body: "Choosing Off Cut Shades for your bedroom shades means opting for unmatched quality and dedication. We offer a 5-year warranty, a satisfaction guarantee, free shipping within 2 days, and all our shades are handcrafted in Canada. Our commitment to providing superior window treatments makes us the preferred choice for enhancing your bedroom's comfort and style",
      },
      {
        title: "Find the Perfect Windows Shades For Your Bedroom",
        body: "Discover the best custom shades for your bedroom directly online with Off Cut Shades. Our easy-to-navigate website allows you to select, customize, and order the perfect shades that meet your style, functionality, and privacy needs. Enhance your bedroom with shades that reflect your personal style and contribute to the benefits of quality sleep.",
        actions: [
          {
            text: "Get Started",
            to: "/shop",
          },
        ],
      },
    ],
  },
  commercial_window_shades: {
    metaTitle:
      "Commercial Shades: Custom Commercial Window Shades | Off Cut Shades",
    metaDesc:
      "Custom window shades for businesses by Off Cut Shades. Order commercial shades at the best prices online, 2-day shipping across Canada.",
    content: [
      {
        title: "Commercial Shades: Custom Window Shades For Businesses",
        body: "Commercial shades are essential for any business seeking to enhance their interior aesthetic while managing natural light efficiently. At Off Cut Shades, we specialize in providing custom window shades designed to meet the diverse needs of commercial applications. Our products are ideal for offices, hotels, hospitals, restaurants, and schools, offering superior quality and energy efficiency.",
        media: {
          type: "Commercial Shades",
          alt: "Commercial Shades",
          src: "/images/shadeinfo/commerical/banner.jpg",
        },
      },
      {
        title: "Shades We Offer For Commercial Properties",
        body: "Off Cut Shades offers a wide range of custom shade solutions tailored to commercial environments. Our selection includes roller, zebra/banded, sheer, snug, bottom-up, dual, and panel track shades, each designed to offer unique benefits and aesthetic appeal. Whether you're looking for solar shade options for glare control or blackout roller shades for maximum privacy, our lineup has something to suit every need.",
      },
      {
        title: "Roller",
        body: "Our roller shades are a popular choice for commercial settings, providing sleek, modern aesthetics along with practical functionality. These shades are available in a variety of materials and designs, including decorative and commercial grade roller shade options. Perfect for achieving light control and energy efficiency, our roller shades can be customized to fit any window size and style.",
        media: {
          type: "Roller Shades",
          alt: "Commercial Roller Shades",
          src: "/images/shadeinfo/commerical/roller2.jpg",
        },
        actions: [
          {
            text: "Explore",
            to: `/shop/info/roller`,
          },
        ],
      },
      {
        title: "Zebra / Banded",
        body: "Zebra or banded shades offer a stylish and versatile option for commercial spaces. These shades feature alternating sheer and opaque bands, allowing for adjustable light control and visual interest. Ideal for settings where both privacy and natural light are valued, zebra shades are perfect for offices and retail stores.",
        media: {
          type: "Zebra/Banded Shades",
          alt: "Commercial Zebra Shades",
          src: "/images/shadeinfo/commerical/interlude.jpg",
        },
        actions: [
          {
            text: "Explore",
            to: `/shop/info/zebra`,
          },
        ],
      },
      {
        title: "Sheer",
        body: "Sheer shades are an excellent choice for spaces that require natural lighting without sacrificing privacy. These shades diffuse sunlight, reducing glare while softly illuminating the interior. Suitable for hospitals, schools, and hotel lobbies, sheer shades enhance any commercial space with their elegant and functional design.",
        media: {
          type: "Sheer Shades",
          alt: "Commercial Sheer Shades",
          src: "/images/shadeinfo/commerical/sheer.jpg",
        },
        actions: [
          {
            text: "Explore",
            to: `/shop/info/sheer`,
          },
        ],
      },
      {
        title: "Snug",
        body: "Snug shades are designed to fit tightly within window frames, providing a clean and minimalistic look. Ideal for restaurants and boutique shops, these shades offer light control and energy efficiency without overwhelming the space’s design.",
        media: {
          type: "Snug Shades",
          alt: "Commercial Snug Shades",
          src: "/images/shadeinfo/shades/aria/1.jpg",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Bottom Up",
        body: "Bottom-up shades are unique in their ability to provide privacy from the lower part of the window while still allowing light to enter from above. This makes them perfect for ground-level commercial spaces like street-facing offices or clinics where privacy is a priority.",
        media: {
          type: "Bottom Up Shades",
          alt: "Commercial Bottom Up Shades",
          src: "/images/shadeinfo/commerical/bottom.jpg",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Dual",
        body: "Dual shades combine two different types of fabrics, allowing for versatility in light control and insulation. These are particularly beneficial in commercial settings where varying degrees of light and privacy are needed throughout the day.",
        media: {
          type: "Dual Shades",
          alt: "Commercial Dual Shades",
          src: "/images/shadeinfo/commerical/dual.jpg",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Panel Track",
        body: "Panel track shades are a contemporary solution for large windows and glass doors, making them ideal for conference rooms and open-plan offices. These shades slide smoothly on a track and can be layered with other window treatments for enhanced functionality and style.",
        media: {
          type: "Panel Track Shades",
          alt: "Commercial Panel Track Shades",
          src: "/images/shadeinfo/commerical/panel.jpg",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Fabrics For Custom Commercial Shades",
        body: "For our custom commercial shades, Off Cut Shades offers an array of fabric choices to cater to different functional and aesthetic requirements. Our fabric options include transparent, sunscreen, and privacy materials, each selected for its quality and performance. Whether you need to maximize natural light or achieve complete room darkening, our fabrics provide effective solutions tailored to the needs of commercial spaces.",
      },
      {
        title: "Privacy",
        body: "Privacy fabrics are designed to shield interiors from external visibility while allowing light to filter through. This makes them ideal for settings like hospitals and office buildings, where both light and privacy are crucial.",
        media: {
          type: "Privacy Fabric",
          alt: "Privacy Fabric For Commercial Shades",
          src: "/images/shadeinfo/fabric/privacy/1.png",
        },
      },
      {
        title: "Sunscreen",
        body: "Sunscreen fabrics are engineered to offer high UV protection while maintaining visibility outdoors. They are perfect for commercial spaces with extensive glass facades, helping to reduce glare and control indoor temperatures without sacrificing the view.",
        media: {
          type: "Sunscreen Fabric",
          alt: "Sunscreen Fabric For Commercial Shades",
          src: "/images/shadeinfo/fabric/sunscreen/1.png",
        },
      },
      {
        title: "Transparent",
        body: "Transparent fabrics are ideal for areas where maximum daylight is desired without compromising on interior visibility. They are particularly beneficial in retail environments and galleries, where natural light can enhance the display and ambiance of the space.",
        media: {
          type: "Transparent Fabric",
          alt: "Transparent Fabric For Commercial Shades",
          src: "/images/shadeinfo/fabric/transparent/1.png",
        },
      },
      {
        title: "Why Choose Off Cut Shades For Commercial Shades",
        body: "Choosing Off Cut Shades means opting for unmatched quality and dedication in the provision of commercial window shades. We stand out with our five-year warranty, satisfaction guarantee, free shipping within two days, and handcrafted shades made in Canada. Our commitment to superior quality and customer satisfaction makes us a leading choice for commercial window treatments.",
      },
      {
        title: "Find the Perfect Windows Shades For Your Business",
        body: "At Off Cut Shades, we make it simple and convenient for you to select the ideal custom shades for your commercial projects. You can easily order your custom commercial shades online, ensuring a seamless experience from selection to installation. With our wide range of fabrics and styles, combined with our expert advice, finding the perfect window treatment solution for your commercial space has never been easier.",
        actions: [
          {
            text: "Get Started",
            to: "/shop",
          },
        ],
      },
    ],
  },
  dining_room_window_shades: {
    metaTitle:
      "Dining Room Shades: Custom Dining Room Window Shades | Off Cut Shades",
    metaDesc:
      "Custom window shades for dining rooms by Off Cut Shades. Order dining room shades at the best prices online, 2-day shipping across Canada.",
    content: [
      {
        title: "Dining Room Shades: Custom Window Shades For Dining Rooms",
        body: "At Off Cut Shades, we specialize in enhancing your dining experience with custom window shades designed specifically for dining rooms. Our unique range of shades not only elevates the aesthetic of your space but also ensures that light is controlled to create a pleasant dining atmosphere. Whether you have a modern dining setup or a more formal dining area, our shades serve as the perfect complement to your décor.",
        media: {
          type: "Dining Room Shades",
          alt: "Dining Room Shades",
          src: "/images/lifestyle/new/dining_room_shades.jpg",
        },
      },
      {
        title: "Shades We Offer For Dining Rooms",
        body: "Off Cut Shades provides a variety of shade types suitable for any dining room window, ensuring that every customer finds the perfect match for their interior style and functional needs. Our offerings include Roller, Zebra/Banded, Sheer, Snug, Bottom Up, Dual, and Panel Track shades, each designed to enhance the privacy and beauty of your dining room space. These options cater to both larger dining areas and more intimate settings, allowing for a customized ambiance that enhances your dining experience.",
      },
      {
        title: "Roller",
        body: "Roller shades from Off Cut Shades are a sleek and efficient option for dining room windows. These shades are easy to operate and come in a range of materials and colors, allowing them to seamlessly integrate into any dining room décor. Ideal for those seeking a minimalist yet stylish window covering, our roller shades provide excellent light control, making them a smart choice for both casual and formal dining settings.",
        media: {
          type: "Roller Shades",
          alt: "Dining Room Roller Shades",
          src: "/images/shadeinfo/shades/roller/1.jpg",
        },
        actions: [
          {
            text: "Explore",
            to: `/shop/info/roller`,
          },
        ],
      },
      {
        title: "Zebra / Banded",
        body: "Zebra or Banded shades offer a striking visual appeal with their dual fabric layers, which alternate between sheer and opaque bands. This design allows for versatile light control and visual privacy, making them a popular choice for dining rooms. With Off Cut Shades, you can adjust the ambiance of your dining room effortlessly, making every mealtime special whether it's a family gathering or a dinner party.",
        media: {
          type: "Zebra/Banded Shades",
          alt: "Dining Room Zebra Shades",
          src: "/images/shadeinfo/shades/banded/1.jpg",
        },
        actions: [
          {
            text: "Explore",
            to: `/shop/info/zebra`,
          },
        ],
      },
      {
        title: "Sheer",
        body: "Sheer shades from Off Cut Shades imbue your dining room with a touch of elegance and sophistication. These shades filter in soft light, creating a warm and inviting atmosphere that enhances the overall dining experience. Perfect for settings that require a delicate touch, our sheer shades are the ideal complement to wood dining furnishings, adding a layer of refined aesthetics to your dining room.",
        media: {
          type: "Sheer Shades",
          alt: "Dining Room Sheer Shades",
          src: "/images/shadeinfo/shades/sheer/1.jpg",
        },
        actions: [
          {
            text: "Explore",
            to: `/shop/info/sheer`,
          },
        ],
      },
      {
        title: "Snug",
        body: "Snug shades are tailored to fit your dining room windows perfectly, providing a clean and well-fitted look. These shades are excellent for maintaining a cozy and intimate dining environment, especially in smaller or uniquely shaped spaces. At Off Cut Shades, we ensure that snug shades meet your exact needs, combining functionality with aesthetic appeal.",
        media: {
          type: "Snug Shades",
          alt: "Dining Room Snug Shades",
          src: "/images/shadeinfo/shades/aria/1.jpg",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Bottom Up",
        body: "Bottom Up shades provide unique control over privacy and light, starting from the bottom of the window and allowing you to adjust exposure as needed. These shades are particularly useful in dining rooms that face busy streets or neighbors, giving you control over the natural light entering the room while maintaining privacy during your dining moments.",
        media: {
          type: "Bottom Up Shades",
          alt: "Dining Room Bottom Up Shades",
          src: "/images/shadeinfo/shades/atlas/1.png",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Dual",
        body: "Dual shades from Off Cut Shades offer the ultimate flexibility in light control and privacy. These shades combine two different types of fabrics, allowing you to switch between light filtering and full privacy with ease. Dual shades are perfect for dining rooms used for various purposes, adapting quickly to your changing needs.",
        media: {
          type: "Dual Shades",
          alt: "Dining Room Dual Shades",
          src: "/images/shadeinfo/shades/dual/1.jpg",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Panel Track",
        body: "Panel Track shades are ideal for larger dining room windows and glass doors. These shades slide smoothly across a track and are excellent for wide spaces, providing substantial coverage with a modern look. Off Cut Shades ensures that these shades not only offer practical benefits but also enhance the overall style of your dining area.",
        media: {
          type: "Panel Track Shades",
          alt: "Dining Room Panel Track Shades",
          src: "/images/shadeinfo/shades/panel-track/1.jpg",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Fabrics For Custom Dining Room Shades",
        body: "To further personalize your dining room shades, Off Cut Shades offers a selection of fabrics that cater to different needs and styles. Our fabric options include Transparent, Sunscreen, Translucent, and Privacy each ensuring that your dining room's aesthetic and functional requirements are met. Whether you're looking for minimal light interference or maximum privacy, our fabrics provide the flexibility to achieve your desired ambiance.",
      },
      {
        title: "Privacy",
        body: "Privacy fabric shades are designed to keep your dining room secluded without sacrificing natural light. These shades allow light to enter the room while keeping the interior view obscured from the outside, perfect for those who value privacy but still appreciate a well-lit dining space.",
        media: {
          type: "Privacy Fabric",
          alt: "Privacy Fabric For Dining Room Shades",
          src: "/images/shadeinfo/fabric/privacy/1.png",
        },
      },
      {
        title: "Sunscreen",
        body: "Sunscreen fabric shades are specifically tailored for those who want to protect their dining room from UV rays while enjoying natural light. These shades reduce glare and heat, making your dining environment more comfortable and protecting your interior from sun damage.",
        media: {
          type: "Sunscreen Fabric",
          alt: "Sunscreen Fabric For Dining Room Shades",
          src: "/images/shadeinfo/fabric/sunscreen/1.png",
        },
      },
      {
        title: "Translucent",
        body: "Translucent fabric shades offer a soft light diffusion that can create a calming and inviting atmosphere in your dining room. These shades are perfect for those who prefer a gentle light that enhances the mood without overpowering the space.",
        media: {
          type: "Translucent Fabric",
          alt: "Translucent Fabric For Dining Room Shades",
          src: "/images/shadeinfo/fabric/translucent/1.png",
        },
      },
      {
        title: "Transparent",
        body: "Transparent fabric shades are ideal for dining rooms that benefit from natural light and scenic views. These shades provide minimal light filtering, keeping your dining room bright and airy while still offering a layer of protection from the external environment.",
        media: {
          type: "Transparent Fabric",
          alt: "Transparent Fabric For Dining Room Shades",
          src: "/images/shadeinfo/fabric/transparent/1.png",
        },
      },
      {
        title: "Why Choose Off Cut Shades For Dining Room Shades",
        body: "Off Cut Shades stands out as the top provider of custom window shades for dining rooms. Our commitment to quality is evident in every shade we produce, all handcrafted in Canada with a focus on durability and aesthetic appeal. We offer a 5-year warranty, a satisfaction guarantee, and free shipping within 2 days, ensuring that our customers receive the best service and products available. Our tailored solutions are designed to meet the specific needs of your dining space, making us the top choice for those seeking the perfect dining room shades.",
      },
      {
        title: "Find the Perfect Window Shades For Your Dining Room",
        body: "Ready to transform your dining room with custom shades? Off Cut Shades invites you to explore our range of options and order directly online. Our user-friendly website makes it easy to customize your shades to suit your style and needs, ensuring that your dining room becomes a highlight of your home. Choose Off Cut Shades for a seamless experience and superior products that elevate your dining environment.",
        actions: [
          {
            text: "Get Started",
            to: "/shop",
          },
        ],
      },
    ],
  },
  home_theatre_window_shades: {
    metaTitle:
      "Home Theatre Shades: Custom Home Theatre Window Shades | Off Cut Shades",
    metaDesc:
      "Custom window shades for home theatre by Off Cut Shades. Order home theatre shades at the best prices online, 2-day shipping across Canada.",
    content: [
      {
        title: "Home Theatre Shades: Custom Window Shades For Home Theatres",
        body: "Home Theatre Shades by Off Cut Shades enhance your cinematic experience with custom window shades specifically designed for home theatres. These shades not only improve the aesthetics of your viewing space but also provide necessary light control to ensure optimal viewing of your favorite films. As a premier provider of window coverings, Off Cut Shades specializes in a variety of designs that cater to every customer's unique needs, ensuring every movie night is perfectly set.",
        media: {
          type: "Home Theatre Shades",
          alt: "Home Theatre Shades",
          src: "/images/lifestyle/new/home_theatre_shades.jpg",
        },
      },
      {
        title: "Shades We Offer For Home Theatres",
        body: "At Off Cut Shades, we understand that each home theatre has its distinct style and functional requirements. We offer a diverse range of shades that include Roller, Zebra/Banded, Sheer, Snug, Bottom Up, Dual, and Panel Track shades. Each type is crafted to enhance your home theatre environment by controlling incoming light and reducing unwanted glare, thus perfecting your movie time with family.",
      },
      {
        title: "Roller",
        body: "Our Roller shades are a sleek and effective choice for any home theatre. Designed to offer versatility and ease, these shades come in various fabrics, including blackout options that are essential for blocking out light during movie viewings. Roller shades by Off Cut Shades are known for their smooth operation and durable, energy-efficient construction that contributes to a comfortable, distraction-free theater window treatment.",
        media: {
          type: "Roller Shades",
          alt: "Home Theatre Roller Shades",
          src: "/images/shadeinfo/shades/roller/1.jpg",
        },
        actions: [
          {
            text: "Explore",
            to: `/shop/info/roller`,
          },
        ],
      },
      {
        title: "Zebra / Banded",
        body: "Zebra or Banded shades offer a modern look with dual fabric layers that create a unique visual effect and allow for adjustable light control. These shades are ideal for home theatres where control over lighting is crucial. The alternating bands can be aligned to block light completely or adjusted to soften incoming light without sacrificing privacy during your viewing experience.",
        media: {
          type: "Zebra/Banded Shades",
          alt: "Home Theatre Zebra Shades",
          src: "/images/shadeinfo/shades/banded/1.jpg",
        },
        actions: [
          {
            text: "Explore",
            to: `/shop/info/zebra`,
          },
        ],
      },
      {
        title: "Sheer",
        body: "Sheer shades are perfect for those who do not prefer complete darkness but appreciate subtle light filtering to enhance the ambiance during a movie with family. These shades provide a touch of elegance while diffusing the harshness of direct sunlight, ensuring your theater window treatments are as beautiful as they are functional.",
        media: {
          type: "Sheer Shades",
          alt: "Home Theatre Sheer Shades",
          src: "/images/shadeinfo/shades/sheer/1.jpg",
        },
        actions: [
          {
            text: "Explore",
            to: `/shop/info/sheer`,
          },
        ],
      },
      {
        title: "Snug",
        body: "Snug shades from Off Cut Shades are tailored to fit precisely within your window frame, eliminating gaps that could let in light. These are ideal for home theatre setups that demand a high level of light control to prevent any glare during critical viewing moments. The snug fit also enhances the overall thermal efficiency of the room, making it comfortable regardless of the outside weather.",
        media: {
          type: "Snug Shades",
          alt: "Home Theatre Snug Shades",
          src: "/images/shadeinfo/shades/aria/1.jpg",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Bottom Up",
        body: "Bottom Up shades offer a unique approach to privacy and light control by allowing you to adjust the shade from the bottom upwards. This feature is particularly beneficial in home theatre environments where you might want to block out street-level light or distractions without completely darkening the room, maintaining a perfect balance for your movie time.",
        media: {
          type: "Bottom Up Shades",
          alt: "Home Theatre Bottom Up Shades",
          src: "/images/shadeinfo/shades/atlas/1.png",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Dual",
        body: "Dual shades provide the ultimate versatility in light control and privacy, combining two types of shades, typically a translucent and a blackout shade in one. This allows for complete customization of your theatre’s lighting atmosphere, from fully lit to pitch black, ensuring an optimal viewing experience without any compromise.",
        media: {
          type: "Dual Shades",
          alt: "Home Theatre Dual Shades",
          src: "/images/shadeinfo/shades/dual/1.jpg",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Panel Track",
        body: "Panel Track shades are the best solution for large home theatre windows or glass doors. These shades slide smoothly on a track and are excellent for wide spaces, providing a clean, contemporary look while being extremely effective at blocking out unwanted light. They can be pulled back to reveal the view outside or closed to create a private, secluded environment for a movie with family.",
        media: {
          type: "Panel Track Shades",
          alt: "Home Theatre Panel Track Shades",
          src: "/images/shadeinfo/shades/panel-track/1.jpg",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Fabrics For Custom Home Theatre Shades",
        body: "Choosing the right fabric is crucial for achieving both the desired aesthetic and functionality in your home theatre. Off Cut Shades offers a range of fabric options including Privacy and Blackout to meet different needs and preferences.",
      },
      {
        title: "Blackout",
        body: "Blackout fabric is essential for any home theatre as it ensures complete darkness, enhancing the contrast and clarity of your projector or TV screen. Our blackout shades come with an optional blackout liner, which provides an additional layer of light blockage, making them perfect for viewing experiences that mimic a real cinema environment.",
        media: {
          type: "Blackout Fabric",
          alt: "Blackout Fabric For Home Theatre Shades",
          src: "/images/shadeinfo/fabric/blackout/1.png",
        },
      },
      {
        title: "Privacy",
        body: "Privacy fabrics are designed to shield your interior from outside view while allowing some light to permeate, ensuring your home theatre remains a private yet lightly illuminated space. These fabrics are ideal for those who prioritize seclusion without creating a completely dark room.",
        media: {
          type: "Privacy Fabric",
          alt: "Privacy Fabric For Home Theatre Shades",
          src: "/images/shadeinfo/fabric/privacy/1.png",
        },
      },
      {
        title: "Why Choose Off Cut Shades For Home Theatre Shades",
        body: "Off Cut Shades is the premier choice for window shades in home theatres. We offer a five-year warranty, satisfaction guarantee, and free shipping within two days. Our products are meticulously handcrafted in Canada, tailored to each client's specifications. With Off Cut Shades, you are guaranteed top-quality, beautiful window treatments that enhance both the style and function of your home theatre space.",
      },
      {
        title: "Find the Perfect Windows Shades For Your Home Theatre",
        body: "Choosing the right shades for your home theatre can significantly enhance your viewing experience. Off Cut Shades makes it easy for you to customize and order the perfect window coverings online. Whether you’re aiming for total blackout during movie nights, or a beautifully lit ambiance for a family gathering, our extensive range of styles and fabrics ensures that you can find exactly what you need.",
        actions: [
          {
            text: "Get Started",
            to: "/shop",
          },
        ],
      },
    ],
  },
  kitchen_window_shades: {
    metaTitle: "Kitchen Shades: Custom Kitchen Window Shades | Off Cut Shades",
    metaDesc:
      "Custom window shades for kitchens by Off Cut Shades. Order kitchen shades at the best prices online, 2-day shipping across Canada.",
    content: [
      {
        title: "Kitchen Shades: Custom Window Shades For Kitchens",
        body: "At Off Cut Shades, we specialize in crafting custom window shades that transform your kitchen into a stylish and functional space. Understanding the unique demands of kitchen windows, our tailored shades offer the perfect kitchen window treatments, allowing natural light to enhance your space while ensuring privacy and aesthetic appeal.",
        media: {
          type: "Kitchen Shades",
          alt: "Kitchen Shades",
          src: "/images/lifestyle/new/kitchen_shades.jpg",
        },
      },
      {
        title: "Shades We Offer For Kitchens",
        body: "Our comprehensive range of custom shades for kitchen windows includes Roller, Zebra/Banded, Sheer, Snug, Bottom Up, Dual, and Panel Track options. Each style is designed to meet diverse needs, from light filtering options to sunscreen options, ensuring you find the perfect match for your home.",
      },
      {
        title: "Roller",
        body: "Roller shades by Off Cut Shades are a sleek and practical choice for kitchen windows. Known for their ease of use and versatility, our roller shades are available in hundreds of designer colours and various performance fabric options. Whether you need to reduce glare or enhance privacy, these shades provide effective solutions without compromising on style.",
        media: {
          type: "Roller Shades",
          alt: "Kitchen Roller Shades",
          src: "/images/shadeinfo/shades/roller/1.jpg",
        },
        actions: [
          {
            text: "Explore",
            to: `/shop/info/roller`,
          },
        ],
      },
      {
        title: "Zebra / Banded",
        body: "Zebra or Banded shades are an excellent choice for those who seek modern elegance. These shades offer a unique mechanism that layers sheer and opaque bands, allowing you to adjust light effortlessly. Perfect for controlling the ambiance in your kitchen, they merge functionality with a contemporary look.",
        media: {
          type: "Zebra/Banded Shades",
          alt: "Kitchen Zebra Shades",
          src: "/images/shadeinfo/shades/banded/1.jpg",
        },
        actions: [
          {
            text: "Explore",
            to: `/shop/info/zebra`,
          },
        ],
      },
      {
        title: "Sheer",
        body: "Sheer shades are ideal for maximizing natural light while softening the sunlight that enters your kitchen. These shades are perfect for creating a light, airy feel in your kitchen, allowing visibility outdoors while filtering harsh UV rays. Our sheer options ensure your kitchen remains bright yet protected.",
        media: {
          type: "Sheer Shades",
          alt: "Kitchen Sheer Shades",
          src: "/images/shadeinfo/shades/sheer/1.jpg",
        },
        actions: [
          {
            text: "Explore",
            to: `/shop/info/sheer`,
          },
        ],
      },
      {
        title: "Snug",
        body: "Snug shades from Off Cut Shades fit your kitchen windows precisely, ensuring no gaps or light leaks. Designed for perfect kitchen window treatments, they are particularly effective in maintaining privacy while offering a tidy, minimalistic look to your window treatments styles.",
        media: {
          type: "Snug Shades",
          alt: "Kitchen Snug Shades",
          src: "/images/shadeinfo/shades/aria/1.jpg",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Bottom Up",
        body: "Bottom Up shades offer a versatile approach to privacy and light control, allowing you to adjust the shade from the bottom up. This feature is particularly useful in kitchens where you want to keep the lower part of the window covered while letting light in from the top.",
        media: {
          type: "Bottom Up Shades",
          alt: "Kitchen Bottom Up Shades",
          src: "/images/shadeinfo/shades/atlas/1.png",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Dual",
        body: "Dual shades combine the features of both sheer and blackout options, making them an excellent choice for kitchen windows. With Off Cut Shades' dual shades, you can adjust the level of light filtering and privacy throughout the day. They are especially suitable for kitchens that face direct sunlight, providing flexibility to adapt to changing light conditions.",
        media: {
          type: "Dual Shades",
          alt: "Kitchen Dual Shades",
          src: "/images/shadeinfo/shades/dual/1.jpg",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Panel Track",
        body: "Panel Track shades are ideal for larger kitchen windows or glass doors. These shades glide smoothly along a track, offering a chic and modern alternative to traditional vertical blinds. Available in a wide range of materials and colors, they provide an elegant solution for wider kitchen spaces, ensuring ease of use and superb light management.",
        media: {
          type: "Panel Track Shades",
          alt: "Kitchen Panel Track Shades",
          src: "/images/shadeinfo/shades/panel-track/1.jpg",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Fabrics For Custom Kitchen Shades",
        body: "When choosing fabrics for your custom kitchen shades, Off Cut Shades offers options like Transparent, Sunscreen, Translucent to cater to various needs and preferences.",
      },
      {
        title: "Transparent",
        body: "Transparent fabrics are perfect for those who do not want to compromise on natural light while adding a subtle layer of protection. These fabrics allow the most light to enter, making your kitchen feel open and welcoming, yet they protect against UV rays that can harm your interiors.",
        media: {
          type: "Transparent Fabric",
          alt: "Transparent Fabric For Kitchen Shades",
          src: "/images/shadeinfo/fabric/transparent/1.png",
        },
      },
      {
        title: "Sunscreen",
        body: "Sunscreen fabrics are engineered to provide excellent UV protection while maintaining your view outdoors. Ideal for kitchens that receive a lot of sunlight, they help prevent glare, protect furniture from fading, and keep your space cooler.",
        media: {
          type: "Sunscreen Fabric",
          alt: "Sunscreen Fabric For Kitchen Shades",
          src: "/images/shadeinfo/fabric/sunscreen/1.png",
        },
      },
      {
        title: "Translucent",
        body: "Translucent fabrics offer a fantastic balance between privacy and natural light. These fabrics obscure the view into your kitchen while softly diffusing sunlight, providing a gentle illumination without the harshness of direct sunlight.",
        media: {
          type: "Translucent Fabric",
          alt: "Translucent Fabric For Kitchen Shades",
          src: "/images/shadeinfo/fabric/translucent/1.png",
        },
      },
      {
        title: "Why Choose Off Cut Shades For Kitchen Shades",
        body: "Choose Off Cut Shades for your kitchen shades to benefit from expert design, a wide range of fabrics, and customization options that ensure you get exactly what you need. Our shades are handcrafted in Canada with a commitment to quality and customer satisfaction, backed by a 5-year warranty and a satisfaction guarantee. Plus, enjoy the convenience of free shipping within 2 days when you order your custom shades online.",
      },
      {
        title: "Find the Perfect Windows Shades For Your Kitchen",
        body: "Ready to enhance your kitchen with custom shades from Off Cut Shades? Shop the full range of styles, from roller shades to panel tracks, and select from hundreds of designer colours and fabric options.",
        actions: [
          {
            text: "Get Started",
            to: "/shop",
          },
        ],
      },
    ],
  },
  residential_window_shades: {
    metaTitle:
      "Residential Shades: Custom Window Shades For Homes | Off Cut Shades",
    metaDesc:
      "Custom window shades for homes by Off Cut Shades. Order residential shades at the best prices online, 2-day shipping across Canada.",
    content: [
      {
        title: "Residential Shades: Custom Window Shades For Homes",
        body: "Residential shades from Off Cut Shades enhance the comfort, privacy, and aesthetics of your home with customized solutions tailored to each window. Our custom window shades offer not only a functional purpose but also add a decorative touch that complements your living space. As a leading provider of custom shades, Off Cut Shades crafts each product to meet individual specifications, ensuring your shades align perfectly with your home’s interior design.",
        media: {
          type: "Residential Shades",
          alt: "Residential Shades",
          src: "/images/lifestyle/new/residential_shades.jpg",
        },
      },
      {
        title: "Shades We Offer For Residential Properties",
        body: "Off Cut Shades specializes in a diverse array of shade options suitable for any residential setting. We provide roller shades, zebra or banded shades, sheer shades, snug shades, bottom-up shades, dual shades, and panel track shades. Each type is designed to offer optimal light control, privacy, and energy efficiency, ensuring that every room in your home can be adapted to meet your needs for comfort and style.",
      },
      {
        title: "Roller",
        body: "Roller shades provided by Off Cut Shades are a sleek and practical choice for residential windows. Known for their simplicity and ease of operation, our roller shades are available in various fabrics, including blackout, translucent, and solar fabrics. These shades are ideal for achieving a minimalistic look while providing effective light control and increasing the energy efficiency of your home.",
        media: {
          type: "Roller Shades",
          alt: "Residential Roller Shades",
          src: "/images/shadeinfo/shades/roller/1.jpg",
        },
        actions: [
          {
            text: "Explore",
            to: `/shop/info/roller`,
          },
        ],
      },
      {
        title: "Zebra / Banded",
        body: "Zebra or banded shades are an elegant option that features alternating sheer and solid fabric bands in a single shade. This unique design allows for light control and privacy without sacrificing style. Off Cut Shades crafts these with precision to create a striking visual effect that enhances the decor of any room.",
        media: {
          type: "Zebra/Banded Shades",
          alt: "Residential Zebra Shades",
          src: "/images/shadeinfo/shades/banded/1.jpg",
        },
        actions: [
          {
            text: "Explore",
            to: `/shop/info/zebra`,
          },
        ],
      },
      {
        title: "Sheer",
        body: "Sheer shades from Off Cut Shades offer a gentle filtering of natural light, creating a soft, luminous atmosphere in any room. These shades are perfect for spaces where you desire light and visibility without compromising on privacy. The delicate, lightweight fabrics used in our sheer shades bring a touch of elegance, seamlessly integrating with diverse interior styles.",
        media: {
          type: "Sheer Shades",
          alt: "Residential Sheer Shades",
          src: "/images/shadeinfo/shades/sheer/1.jpg",
        },
        actions: [
          {
            text: "Explore",
            to: `/shop/info/sheer`,
          },
        ],
      },
      {
        title: "Snug",
        body: "Snug shades are designed to fit closely within the frame of your windows, minimizing gaps and maximizing functionality. Ideal for homeowners seeking a tailored look, snug shades at Off Cut Shades are custom-fitted to ensure perfect window coverings that enhance thermal efficiency and reduce light leakage, making them a smart choice for both aesthetic and practical purposes.",
        media: {
          type: "Snug Shades",
          alt: "Residential Snug Shades",
          src: "/images/shadeinfo/shades/aria/1.jpg",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Bottom Up",
        body: "Bottom-up shades provide a versatile approach to privacy and light control, allowing you to adjust the shade from the bottom upwards. This type of fabric at Off Cut Shades is particularly useful in rooms requiring privacy without sacrificing natural light. Bottom-up shades are custom-made to align with your specific preferences and needs, offering a functional yet stylish custom window treatment.",
        media: {
          type: "Bottom Up Shades",
          alt: "Residential Bottom Up Shades",
          src: "/images/shadeinfo/shades/atlas/1.png",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Dual",
        body: "Dual shades from Off Cut Shades combine the benefits of two different shade types in one mechanism, offering a versatile solution for optimal light control. These shades allow you to transition between sheer and opaque fabrics, adjusting the lighting and privacy levels throughout the day. Dual shades are particularly popular among homeowners looking for both functionality and modern aesthetics in their window treatments.",
        media: {
          type: "Dual Shades",
          alt: "Residential Dual Shades",
          src: "/images/shadeinfo/shades/dual/1.jpg",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Panel Track",
        body: "Panel track shades are an excellent choice for large windows and patio doors, providing sleek functionality and contemporary style. Off Cut Shades designs these shades to slide smoothly across a track, offering significant coverage with easy operation. Panel track shades are available in a variety of fabrics, making them a versatile option for enhancing larger spaces with a touch of sophistication.",
        media: {
          type: "Panel Track Shades",
          alt: "Residential Panel Track Shades",
          src: "/images/shadeinfo/shades/panel-track/1.jpg",
        },
        actions: [
          {
            text: "Contact for Quote",
            to: `/contact`,
          },
        ],
      },
      {
        title: "Fabrics For Custom Residential Shades",
        body: "At Off Cut Shades, we understand that the choice of fabric is essential in achieving the perfect window coverings. Our selection includes transparent, sunscreen, translucent, privacy, and blackout fabrics. Each type of fabric offers distinct benefits: transparent fabrics preserve your view while lightly diffusing sunlight; sunscreen fabrics protect against UV rays and reduce solar heat; translucent fabrics provide privacy while allowing natural light to filter through; privacy fabrics ensure full privacy without complete light blockage; and blackout fabrics offer complete darkness for optimal sleep quality and energy efficiency.",
      },
      {
        title: "Blackout",
        body: "Blackout fabrics are the ultimate solution for anyone needing to completely block out light in Residentials, home theaters, or any room requiring darkness. At Off Cut Shades, our blackout shades combine functionality with elegance, ensuring that these practical solutions also contribute to your home's aesthetic value. They are perfect for improving sleep quality and adding an extra layer of insulation to your windows.",
        media: {
          type: "Blackout Fabric",
          alt: "Blackout Fabric For Residential Shades",
          src: "/images/shadeinfo/fabric/blackout/1.png",
        },
      },
      {
        title: "Privacy",
        body: "Privacy fabrics at Off Cut Shades are designed to keep your home shielded from outside eyes without sacrificing light and airiness. These fabrics are ideal for bathrooms, Residentials, and street-facing windows where privacy is paramount. Our privacy shades maintain an inviting interior atmosphere while ensuring your comfort and security.",
        media: {
          type: "Privacy Fabric",
          alt: "Privacy Fabric For Residential Shades",
          src: "/images/shadeinfo/fabric/privacy/1.png",
        },
      },
      {
        title: "Sunscreen",
        body: "Sunscreen fabrics are specially crafted to offer high levels of UV protection, making them an excellent choice for conservatories, sunrooms, and any area exposed to extensive sunlight. These fabrics at Off Cut Shades help maintain cooler temperatures and protect your furnishings from sun damage, all while keeping your spaces light and bright.",
        media: {
          type: "Sunscreen Fabric",
          alt: "Sunscreen Fabric For Residential Shades",
          src: "/images/shadeinfo/fabric/sunscreen/1.png",
        },
      },
      {
        title: "Translucent",
        body: "Translucent fabrics provide a perfect balance between privacy and natural light. These fabrics softly diffuse sunlight, creating a warm, welcoming glow throughout your space. At Off Cut Shades, translucent shades are often selected for living areas and kitchens where both light and privacy are needed.",
        media: {
          type: "Translucent Fabric",
          alt: "Translucent Fabric For Residential Shades",
          src: "/images/shadeinfo/fabric/translucent/1.png",
        },
      },
      {
        title: "Transparent",
        body: "Transparent fabrics are ideal for maximizing daylight and preserving your outside view. Off Cut Shades offers these fabrics for customers looking to enhance their space with natural light without the drawbacks of direct sunlight and glare. Transparent shades are perfect for areas where you want to enjoy the landscape without barriers.",
        media: {
          type: "Transparent Fabric",
          alt: "Transparent Fabric For Residential Shades",
          src: "/images/shadeinfo/fabric/transparent/1.png",
        },
      },
      {
        title: "Why Choose Off Cut Shades For Residential Shades",
        body: "Off Cut Shades is the affordable choice for custom window shades, offering a five-year warranty, satisfaction guarantee, and free shipping within two days. Our handcrafted shades in Canada are designed with both style and durability in mind. Whether you are looking for energy-efficient solutions or the perfect aesthetic touch, our extensive range of custom shades and fabrics ensures that you will find exactly what you need to make your house a home.",
      },
      {
        title: "Find the Perfect Windows Shades For Your Home",
        body: "Discover the ideal custom residential shades for your home with Off Cut Shades. Easily order your custom window treatments online, and enjoy a transformed space that reflects both your style and functional needs. With our expertly crafted shades, you're just a few clicks away from the perfect ambiance and comfort.",
        actions: [
          {
            text: "Get Started",
            to: "/shop",
          },
        ],
      },
    ],
  },
  skylight_roller_shades: {
    metaTitle:
      "Skylight Roller Shades: Custom Skylight Roller Shades | Off Cut Shades",
    metaDesc:
      "Custom skylight roller shades by Off Cut Shades. Order skylight roller shades at the best prices online, 2-day shipping across Canada.",
    content: [
      {
        title: "Skylight Roller Shades",
        body: "Skylights are perfect to allow natural daylight into a room and give it a more open feeling. But they come with the challenge of what to do when trying to cover them to keep the heat out or darken the room. Off Cut Shades has the solution with skylight roller shades that give you full control over how much coverage you want.",
        media: {
          type: "Skylight Roller Shades",
          alt: "Skylight Roller Shades",
          src: "/images/shadeinfo/shades/nimbus.jpg",
        },
      },
      {
        title: "Custom Skylight Roller Shade Options",
        body: "Choose from a wide range of fabrics, valances and controls to get the perfect skylight roller shade to match your decor while enjoying the benefits of functionality.",
      },
      {
        title: "Why Choose Off Cut Shades For Skylight Shades?",
      },
      {
        title: "High Quality Materials",
        body: "Off Cut Shades is committed to high-quality materials to match our level of service. Whether you are looking for blackout fabrics or sunscreen, we have the perfect option for you to create an inviting and comfortable space year-round.",
      },
      {
        title: "Custom Skylight Shades to Fit Any Space",
        body: "Our customization options allow you to tailor your skylight roller shade exactly to your requirements, from the material and type to the exact size you need. Each shade is made to order to guarantee a perfect fit in any space.",
      },
      {
        title: "Installation Process For Skylight Roller Shades",
      },
      {
        title: "Professional Measurement Services",
        body: "Contact Off Cut Shades today to take advantage of our professional measurement services. We understand that getting the perfect measurements can be challenging, especially for skylights with their placement and location. So let our experienced experts take care of measuring to ensure a perfect fit.",
      },
      {
        title: "Expert Installation",
        body: "Our professional technicians will take care of the entire installation process as well, ensuring your custom skylight roller blinds are perfectly installed to your full satisfaction.",
      },
      {
        title: "Post-Installation Support",
        body: "Off Cut Shades also offers post-installation support on our custom skylight roller shades. Whether you experience an issue with the fabric, fit or installation, we will work with you to find the best and most efficient solution to the issue. ",
      },
      {
        title: "Request a Custom Skylight Roller Shade Quote",
        body: "Contact us today and take advantage of our custom skylight roller shades with a free, no-obligation quote! Professionally measured, made to order and expertly installed, we will do whatever we can for you to love your shades.",
      },
    ],
  },
  graphic_shades: {
    metaTitle: "Graphic Shades: Custom Graphic Window Shades | Off Cut Shades",
    metaDesc:
      "Custom graphic shades by Off Cut Shades. Order graphic window shades at the best prices online, 2-day shipping across Canada.",
    content: [
      {
        title: "Graphic Shades",
        body: "Sometimes you want more than just a regular fabric or texture, so why not take it a step further with Off Cut Shades’ graphic shades? Introduce fun patterns and colours that can bring a pop to the room without having to redecorate everything!",
        media: {
          type: "Graphic Shades",
          alt: "Graphic Shades",
          src: "/images/shadeinfo/shades/graphic_shade.jpg",
        },
      },
      {
        title: "Custom Graphic Shade Options",
        body: "Choose from a wide range of fun graphics, valances and controls to get the perfect graphic shade to match your decor while enjoying the benefits of functionality.",
      },
      {
        title: "Why Choose Off Cut Shades For Graphic Shades?",
      },
      {
        title: "High Quality Materials",
        body: "Off Cut Shades is committed to high-quality materials to match our level of service. Whether you want to add some extra fun to your kid’s room, want to create a theme in your living room or create some funky accents in your den, we have the perfect option for you.",
      },
      {
        title: "Custom Graphic Shades For Any Room",
        body: "Our custom graphic shades give you full control to let your inspiration take over for any room, from your kitchen and living room to your bedroom or den. Understated and elegant or bold and fun, you can find something that will match your style, made to order to guarantee a perfect fit in any room and space.",
      },
      {
        title: "Installation Process For Graphic Shades",
      },
      {
        title: "Professional Measurement Services",
        body: "Contact Off Cut Shades today to take advantage of our professional measurement services. We understand that getting the perfect measurements can be challenging. So let our experienced experts take care of measuring to ensure a perfect fit.",
      },
      {
        title: "Expert Installation",
        body: "Our professional technicians will take care of the entire installation process as well, ensuring your custom graphic shades are perfectly installed to your full satisfaction. ",
      },
      {
        title: "Post-Installation Support",
        body: "Off Cut Shades also offers post-installation support on our custom graphic shades. Whether you experience an issue with the fabric, fit or installation, we will work with you to find the best and most efficient solution to the issue.",
      },
      {
        title: "Request a Custom Graphic Shade Quote",
        body: "Contact us today and take advantage of our custom graphic shades with a free, no-obligation quote! Professionally measured, made to order and expertly installed, we will do whatever we can for you to love your shades.",
      },
    ],
  },
};

export {
  shadeTypeDetails,
  ValanceOptions,
  shadeMetaDetails,
  allProducts,
  roomTypeMappings,
};
